import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import InGameValueCard from "../InGameValueCard";
import {CargoNames, CLIENT_NAMES, DAY_NAMES} from "../../../constants/Constants";
import GameData from "../../../gameplay/model/GameData";
import GameButtonWithText from "../GameButtonWithText";
import {GREEN_GRADIENT, RED_GRADIENT} from "../GameStyleUI";

export default class TendersPlaceOrderPopup extends React.Component {
    constructor() {
        super();

        this.state = {
            isConfirmed: false
        };
    }

    render() {
        let tender = this.props.tender;
        let client = CLIENT_NAMES[tender.order.client] || "";
        let cargo = CargoNames[tender.order.trainCarType] || "";

        let npsData = GameData.CurrentGame.nps;

        let nps = Object.keys(npsData).reduce((acc, cur) => acc + npsData[cur], 0);
        let expData = GameData.CurrentGame.exp;
        let exp = Object.keys(expData).reduce((acc, cur) => acc + expData[cur], 0);

        this.cost = 300;

        let content = <div className={"tenders-offer_body"} style={{padding: "1px 10px"}}>
            <div className="top-table">
                <InGameValueCard title={"Заказчик"} value={0} height={30} type={0} subtype={0}/>
                <div className="no-value">
                    <InGameValueCard title={"Груз"} value={0} height={30} type={1} subtype={0}/>
                </div>
                <InGameValueCard className="no-title" value={client} height={30} type={1} subtype={1}/>
                <InGameValueCard className="no-title" value={cargo} height={30} type={1} subtype={1}/>
            </div>

            <InGameValueCard
              title={"Тариф за тонну"}
              isEditable={true}
              value={this.cost}
              maxValue={300}
              onChange={(n) => {this.cost = +n <= 300 ? +n : this.cost;}}
              height={40}
              type={1}
              subtype={1}
              border={'2px solid rgb(86, 204, 242)'}
            />
            <div style={{textAlign: "left"}}>
                <InGameValueCard title={"Первая подача клиенту порожних вагонов под погрузку на станции отправления (День недели)"} onChange={(n) => {this.loadDay = n}} hideButton={true} isEditable={true} selectData={DAY_NAMES} height={40} type={1} subtype={2}/>
                <InGameValueCard title={"Первая подача клиенту груженых вагонов под выгрузку на станции назначения (День недели)"} onChange={(n) => {this.unloadDay = n}} hideButton={true} isEditable={true} selectData={DAY_NAMES} height={40} type={1} subtype={1}/>
            </div>
            <InGameValueCard title={"Индекс клиентоориентированности"} value={nps} height={20} type={1} subtype={2}/>
            <InGameValueCard title={"Индекс накопленного опыта"} value={exp} height={20} type={1} subtype={1}/>
            <InGameValueCard
              title={"Кредит (%)"} minValue={1} maxValue={99} isEditable={true} value={99}
              onChange={(n) => {this.credit = n}} height={40} type={1} subtype={2}
              border={'1px solid rgb(86, 204, 242)'}
            />
            <InGameValueCard title={"Стоимость участия"} value={3000000} height={20} type={1} subtype={0}/>

            {!this.props.isBought && <div className="buttons" style={{marginTop: "20px"}}>
                <GameButtonWithText width={118} height={40} title={"Отмена"}
                                    colorStart={RED_GRADIENT[0]} colorEnd={RED_GRADIENT[1]}
                                    onClick={this.props.onCancel} style={{marginRight: "10px"}}/>
                <GameButtonWithText width={118} height={40} title={"Отправить"}
                                    colorStart={GREEN_GRADIENT[0]} colorEnd={GREEN_GRADIENT[1]}
                                    onClick={() => {
                                        let data = {
                                            tenderId: tender.id,
                                            costPerTon: this.cost || 300,
                                            loadDay: this.loadDay || 0,
                                            unloadDay: this.unloadDay || 0,
                                            nps: nps,
                                            exp: exp,
                                            credit: this.credit || 99
                                        }

                                        this.props.onOk(data);
                                    }} />
            </div>}
        </div>;

        return <div className={"tenders-offer container__shadow"}>
            <div className="tenders-offer__content container__content">
                <GameWindowHeader width={500} height={40} onHide={this.props.onHide} isClosable={true}
                                  title={"Тендеры"}/>
                <GameWindowBg width={500} height={400} value={content}/>
            </div>
        </div>;
    }
}
